/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Cell, Grid, HFlow, Icon, IconImage, Text } from 'bold-ui'
import { useTheme } from 'emotion-theming'
import React from 'react'

interface AntropometriaGridItemProps {
  titulo: string
  iconName?: IconImage
  icon?: React.ReactElement
  children?: React.ReactNode
}

export function AntropometriaGridItem(props: Readonly<AntropometriaGridItemProps>) {
  const { titulo, iconName, icon, children } = props

  const theme = useTheme()
  const styles = createStyles(theme)

  return (
    <div css={styles.div}>
      <Grid gap={1} alignItems='flex-start'>
        <Cell size={12} alignSelf='center'>
          <HFlow alignItems='center' hSpacing={0.5}>
            {icon || <Icon icon={iconName} color='primary' size={1.5} />}
            <Text variant='h4'>{titulo}</Text>
          </HFlow>
        </Cell>
        {children}
      </Grid>
    </div>
  )
}

const createStyles = (theme) => ({
  div: css`
    padding: 1rem;
    border-top: 1px solid ${theme.pallete.divider};
  `,
})
